<template>
  <section class="fixed inset-0 flex items-center justify-center z-[31] bg-black bg-opacity-30 backdrop-blur-sm mt-[70px]">
    <div id="modal modal-customer" class="modal absolute block w-5/6 sm:w-9/12 md:w-5/12 bg-white shadow-md rounded-lg"
      :class="{
        'animate__animated animate__zoomIn': showModal,
        'animate__animated animate__zoomOut': !showModal,
      }">
      <div id="modal-header" class="w-full bg-color-1 py-3 rounded-t-lg">
        <h5 class="text-white text-center font-bold text-xl">PIN</h5>
      </div>
      <div id="modal-body" class="p-5">
        <InputText v-model="pin" id="pin" label="PIN" placeholder="Masukkan PIN" input_class="w-full" type="password" />
      </div>
      <div class="modal-footer p-5">
        <div class="flex justify-center">
          <SubmitButton id="close" button_name="Close"
            button_class="mx-1 text-red-600 border-red-600 hover:text-white hover:bg-red-600" @click="closeModal" />
          <SubmitButton id="submit" button_name="Submit" button_class="mx-1 bg-color-1 hover:bg-color-2 text-color-4"
            @click="submitPin" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import InputText from '@/components/form/InputText.vue';
import SubmitButton from '@/components/form/SubmitButton.vue';

export default {
  name: "ModalPin",
  props: {
    idGlobalDiscount: {
      type: String,
      default: '',
    }
  },
  components: {
    SubmitButton, InputText
  },
  data() {
    return {
      showModal: true,
      pin: '',
      id: this.idGlobalDiscount ? this.idGlobalDiscount : '',
    }
  },
  methods: {
    closeModal(isClose = true) {
      this.showModal = false;
      setTimeout(() => {
        this.$emit('closeModal', isClose);
      }, 200);
    },
    submitPin() {
      try {
        this.$emit('submitpin', {pin : this.pin, selected_id : this.id});

        this.closeModal(false);
      }
      catch (error) {
        console.error('Failed to save item:', error);
      }
    }
  }
}
</script>